/**
 * This vuex store must be used with
 * Onboarding component
 * The purpose of this vuex currently is
 * for handling Onboarding Goldplus Pop up modal
 */
export const state = () => ({
  isShowModalOnboardingGoldplus: false,
  isLoading: false,
  dataOnboarding: [],
});

export const getters = {
  isShowModalOnboardingGoldplus(state) {
    return state.isShowModalOnboardingGoldplus;
  },
  isLoading(state) {
    return state.isLoading;
  },
  dataOnboarding(state) {
    return state.dataOnboarding;
  },
};

export const mutations = {
  setIsShowModalOnboardingGoldplus(state, value) {
    state.isShowModalOnboardingGoldplus = value;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
  setDataOnboarding(state, value) {
    state.dataOnboarding = value;
  },
};

export const actions = {
  async fetchOnboardingGoldplus({ commit }) {
    commit('setLoading', true);
    try {
      const response = await this.$api.getOnboardingPreSubmission({
        v: '2',
      });

      if (response.data.status) {
        const onboardingGoldplus = response.data?.onboarding || [];
        commit('setDataOnboarding', onboardingGoldplus);
      }
    } catch (error) {
      this.$error.report(error);
    } finally {
      commit('setLoading', false);
    }
  },
};
